import { MAPPING } from '@/utils/event/constants.ts';
import { emitter } from '@/utils/event/emitter.ts';

export default function processMessages(response) {
    const messages = response.data?.messages;

    if (!messages) return false;

    emitter.emit(MAPPING.MESSAGES, messages);

    return true;
}
